import { TFunction } from 'i18next'

import { rootFolder } from '../../../constants/rootFolder'
import { FolderPathBreadcrumbItem } from '../../../types/folderPathBreadcrumbItem'

export const getFolderName = (folder: FolderPathBreadcrumbItem, t: TFunction) =>
  folder.id === rootFolder.id ? t(folder.name) : folder.name
